import { RedWarningIcon, WarningCloseIcon } from 'app/assets/icons';
import React from 'react';
import styled from 'styled-components';
import { convertDateToDDMMYYYY } from 'utils/common';

type Props = {
  renewalDate?: string;
  daysThreshold?: number;
  label: string;
  className?: string;
  isCloseIcon?: boolean;
  onCloseClick?: () => void;
  showWarningLabel?: boolean;
};

const ExpiryAlert = ({
  renewalDate,
  daysThreshold,
  label,
  className,
  isCloseIcon,
  onCloseClick,
  showWarningLabel,
}: Props) => {
  const currentDate = new Date();
  const expiryDate = new Date(renewalDate ?? '');
  currentDate.setHours(0, 0, 0, 0);
  expiryDate.setHours(0, 0, 0, 0);
  const timeDifference = expiryDate.getTime() - currentDate.getTime();
  const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  let message = '';

  if (daysRemaining > 1 && daysRemaining <= (daysThreshold ?? 0)) {
    message = `Expire in ${daysRemaining} days`;
  } else if (daysRemaining === 1) {
    message = `Expires in ${daysRemaining} day`;
  } else if (daysRemaining === 0) {
    message = 'Expire today';
  } else if (daysRemaining < 0) {
    message = `Expired on ${convertDateToDDMMYYYY(expiryDate.toISOString()) ?? ''}`;
  }

  return (
    <AlertContainer className={className}>
      <IconContainer className="icon-container">
        <RedWarningIcon />
      </IconContainer>
      <Message className="message">
        {showWarningLabel ? label : message}
      </Message>
      {isCloseIcon && (
        <div className="close-icon">
          <WarningCloseIcon onClick={onCloseClick} />
        </div>
      )}
    </AlertContainer>
  );
};

export default ExpiryAlert;

const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  width: 310px;
  height: 52px;
  border-radius: 5px;
  background: ${p => p.theme.alertBackgroundClr};
  border: 1px solid ${p => p.theme.alertBorderClr};
  &.modify-loan-expiry-alert {
    margin-top: 16px;
    width: 100%;
  }
  .close-icon {
    display: flex;
    padding: 0px 10px;
    padding-left: 18px;
  }
`;

const IconContainer = styled.div`
  padding: 0px 23px 0 18px;
  display: flex;
  align-items: center;
`;

const Message = styled.div`
  flex: 1;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  text-align: left;
  color: ${p => p.theme.alertlabelClr};
`;